import MiniProgramPage from 'D:/HBuilderProjects/园博园/pages/index/index.vue'
wx.createPage(MiniProgramPage)